import { render } from "./auto-reply.vue?vue&type=template&id=2948eb45&scoped=true"
import script from "./auto-reply.vue?vue&type=script&lang=js"
export * from "./auto-reply.vue?vue&type=script&lang=js"

import "./auto-reply.vue?vue&type=style&index=0&id=2948eb45&scoped=true&lang=css"

import exportComponent from "D:\\Project\\crosstechno\\crm-frontend-v2\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2948eb45"]])

export default __exports__